// import logo from './logoTrans.png';
import './App.css';
import { useEffect, useState } from 'react';

function App() {

  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    setIsMobile(() => /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
  })

  const blueColor = { color: 'blue'}
  const redColor = { color: 'red'}

  return (
    <div className="App">
      <img src='logoTrans.png' alt='logo' style={{width: isMobile ? "50%" : "20%", marginTop: 100}}/>

      <h3 style={{marginTop: "30px" ,...blueColor}}>Dragi posetioci sajta i čitaoci Akatista</h3>
      <h3  style={{marginTop: "20px" ,...blueColor}}>Zbog tehničkog unapređenja sajta, sajt</h3>
      <h3  style={blueColor}>će ponovo biti dostupan kroz 7 dana.</h3>

      <h3 style={{marginTop: "20px", ...redColor}}>Za sva pitanja, pišite na instagram</h3>
      <h3 style={redColor}>@dijana.duhovnostupraksi</h3>

      <h3  style={{marginTop: "20px" ,...blueColor}}>Hvala Vam na razumevanju i strpljenju,</h3>
      <h3  style={blueColor}>vaša Hadži Dijana Ninić</h3>

    </div>
  );
}

export default App;
 